import { gql } from 'graphql-request'

export const SendWoolstoreSpeciEmailGql = gql`
  mutation sendToWoolStore(
    $emailMessage: String!
    $emailSubject: String!
    $speciId: UUID!
    $woolStoreEmailAddress: String!
    $bccMyself: Boolean!
  ) {
    sendToWoolStore(
      request: {
        emailMessage: $emailMessage
        emailSubject: $emailSubject
        speciId: $speciId
        woolStoreEmailAddress: $woolStoreEmailAddress
        bccMyself: $bccMyself
      }
    ) {
      errorMessage
      success
    }
  }
`
